// extracted by mini-css-extract-plugin
export default {"container":"app-loading_container__Vd1Lp","loading":"app-loading_loading__hwLtz"};